import { SITE } from "./seo.config";

// Drops empty values so we never publish blank fields.
const clean = (o) => Object.fromEntries(Object.entries(o).filter(([, v]) => v !== "" && v != null));

export const localBusinessSchema = clean({
  "@context": "https://schema.org",
  "@type": "HomeAndConstructionBusiness",
  "@id": `${SITE.url}/#business`,
  name: SITE.name,
  legalName: SITE.legalName,
  alternateName: SITE.alternateNames,
  url: `${SITE.url}/`,
  logo: SITE.logo,
  image: SITE.ogImage,
  telephone: SITE.phone,
  email: SITE.email,
  description:
    "Borehole drilling, water surveys, pump installation, solar installation and solar water pumping for homes, farms and businesses in Kenya.",
  address: { "@type": "PostalAddress", ...clean(SITE.address) },
  geo: { "@type": "GeoCoordinates", latitude: SITE.geo.lat, longitude: SITE.geo.lng },
  areaServed: [
    ...SITE.countriesServed.map((name) => ({ "@type": "Country", name })),
    ...SITE.townsServed.map((name) => ({ "@type": "Place", name })),
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: SITE.hours.days,
      opens: SITE.hours.opens,
      closes: SITE.hours.closes,
    },
  ],
  sameAs: SITE.sameAs.length ? SITE.sameAs : "",
  knowsAbout: ["Borehole drilling", "Hydrogeological surveys", "Solar water pumping", "Pump installation"],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Water and solar services",
    itemListElement: [
      "Borehole drilling",
      "Water surveys and siting",
      "Pump installation",
      "Solar installation",
      "Solar water pumping",
      "Pump maintenance and repairs",
    ].map((name) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name } })),
  },
});

// Tells Google the site's name, which it can use as the site name in results.
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE.url}/#website`,
  name: SITE.name,
  alternateName: ["Maji Maji Hub", "MajiMaji Hub Ltd"],
  url: `${SITE.url}/`,
  inLanguage: "en-KE",
  publisher: { "@id": `${SITE.url}/#business` },
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE.url}${it.path === "/" ? "/" : it.path}`,
  })),
});

// Do NOT add Review/AggregateRating markup until you have real, verifiable reviews.